import Image from "next/image";

interface IDownloads {
  downloads?: {
    downloads?:
      | {
          name: string;
          description?: string;
          icon: {
            sourceUrl: string;
          };
          file: {
            mediaItemUrl: string;
          };
        }[]
      | null;
  } | null;
}

export const Downloads = ({ downloads }: IDownloads) => (
  <div className="mt-4 flex flex-col">
    {downloads?.downloads?.map((download) => {
      const link =
        download.file?.mediaItemUrl?.replace(
          "https://kns.you2.pl/wp-content",
          ""
        ) || "";
      return (
        <div className="flex w-full border" key={download.name}>
          <div className="w-20">
            <a href={`${link}`} rel="noopener" target="_blank">
              <Image
                alt={download.name}
                height={64}
                src={
                  download.icon?.sourceUrl
                    ? download.icon?.sourceUrl
                    : "/img/assets/download.png"
                }
                width={64}
              />
            </a>
          </div>
          <div className="my-auto font-bold text-lg hover:underline">
            <a href={`${link}`} rel="noopener" target="_blank">
              {download.name}
            </a>
            {download.description && (
              <p className="text-gray-600 text-sm">{download.description}</p>
            )}
          </div>
        </div>
      );
    })}
  </div>
);
